var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,{"setDrawingMode":_vm.setDrawingMode,"deleteSelection":_vm.deleteSelection})],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/forge/bpbauto.stagingwebsite.dev/web/app/themes/bpb/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/forge/bpbauto.stagingwebsite.dev/web/app/themes/bpb/node_modules/vue-loader/lib?{}!/home/forge/bpbauto.stagingwebsite.dev/web/app/themes/bpb/node_modules/gmap-vue/dist/components/drawing-manager.vue?vue&type=template&id=615a2184&
// module id = 108
// module chunks = 0